<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{amenityName ? amenityName : 'New Booking'}}</h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm step-guide amenity-progress">
                        <div (click)="moveToTheNextStep('amenity')" class="mtv-primary-color">
                            <span>Amenity</span>
                        </div>
                        <div (click)="moveToTheNextStep('terms')"
                             *ngIf="termsAndConditions || amenityConfirmationMessage"
                             [ngClass]="{'mtv-primary-color': (step == 'terms' || step == 'disclaimer' || step == 'details' || step == 'payment' || step == 'summary')}">
                            <span>Terms & Conditions</span>
                        </div>
                        <div (click)="moveToTheNextStep('details')"
                             [ngClass]="{'mtv-primary-color': ( step == 'details' || step == 'disclaimer' || step == 'payment' || step == 'summary')}">
                            <span>Details</span>
                        </div>
                        <div (click)="moveToTheNextStep('disclaimer')"
                             *ngIf="disclaimerText"
                             [ngClass]="{'mtv-primary-color': (step == 'disclaimer' || step == 'payment' || step == 'summary')}">
                            <span>Disclaimer</span>
                        </div>
                        <div (click)="moveToTheNextStep('payment')"
                             *ngIf="availablePaymentMethods.length && amenityFees.length"
                             [ngClass]="{'mtv-primary-color': (step == 'payment' || step == 'summary')}">
                            <span>Payment</span>
                        </div>
                        <div (click)="moveToTheNextStep(showQuoteCheckbox() ? 'quotes' : 'summary')"
                             [ngClass]="{'mtv-primary-color': step == 'summary' || step == 'quotes'}">
                            <span>Summary</span>
                        </div>
                    </div>
                    <div class="row m-b-md step-progress-bar" *ngIf="false">
                        <div class="col-sm-3" [ngStyle]="{ 'width': calculateCurrentProgressBarLength() }"></div>
                    </div>

                    <div class="tab-content" *ngIf="step == 'amenity'">

                        <!-- ___ Type ___ -->
                        <div class="row m-b-sm hidden">
                            <div class="col-md-4">
                                <label>Type</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control" name="bookingType" [(ngModel)]="bookingType">
                                    <option value="booking">Booking</option>
                                    <option value="event">Event</option>
                                </select>
                            </div>
                        </div>

                        <!-- ___ Building ___ -->
                        <div [ngStyle]="{'display': authService.userIsResident? 'none':'block'}" class="row m-b-sm">
                            <div class="col-xs-4 col-md-4">
                                <label>Building</label>
                            </div>
                            <div *ngIf="authService.userIsResident" class="col-xs-8 col-md-8">
                                {{getBuildingNameById(data.buildingId)}}
                            </div>
                            <div *ngIf="!authService.userIsResident" class="col-xs-8 col-md-8">
                                <select class="form-control" name="buildingId" #buildingSelect
                                        [(ngModel)]="data.buildingId"
                                        (change)="changeBuilding($event.target.value)"
                                        [disabled]="!amenitiesService.buildingsForUpdate.length ||
                                                    amenitiesService.modalAmenitiesLoadingSpinnerShow"
                                        required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let build of amenitiesService.buildingsForUpdate"
                                            [value]="build.id">{{build.name}}</option>
                                </select>
                                <spinner [spinnerShow]="!amenitiesService.buildingsForUpdate.length"></spinner>
                            </div>
                        </div>

                        <div *ngIf="data.buildingId" class="amenity-tiles-container">
                            <ul class="amenity-tiles-wrapper">
                                <li class="amenity-tiles-item"
                                     *ngFor="let amenity of amenitiesService.amenitiesByBuilding"
                                     [ngClass]="{'selected': (!amenity.isEvent && amenity.id == data.amenity) || (amenity.isEvent && amenity.eventId == data.amenity),
                                                 'hidden': amenity.isEvent && bookingType == 'event'}"
                                     (click)="selectAmenity(amenity)">
                                    <div class="amenity-tiles-content">
                                        <img *ngIf="amenity.amenityImage && !imageIsSvg(amenity.amenityImage)"
                                             class="amenity-tiles-item-image" [src]="amenity.amenityImage">
                                        <div class="amenity-image-svg"
                                             *ngIf="amenity.amenityImage && imageIsSvg(amenity.amenityImage)"
                                             [ngStyle]="{'mask-image': 'url(' + amenity.amenityImage + ')',
                                                         '-webkit-mask-image': 'url(' + amenity.amenityImage + ')'}">
                                        </div>
                                        <div *ngIf="!amenity.amenityImage" class="amenity-tiles-item-image"></div>
                                    </div>
                                    <div class="amenity-tiles-item-name">{{amenity.name}}</div>
                                </li>
                            </ul>

                            <hr *ngIf="amenitiesService.eventsByBuilding.length > 0">

                            <ul class="amenity-tiles-wrapper">
                                <li class="event-tiles-item"
                                    *ngFor="let event of amenitiesService.eventsByBuilding"
                                    [ngClass]="{'mtv-primary-border': (!event.isEvent && event.id == data.amenity) || (event.isEvent && event.eventId == data.amenity),
                                                 'hidden': event.isEvent && bookingType == 'event'}"
                                    (click)="selectAmenity(event)">
                                    <div class="amenity-tile">
                                        <div class="amenity-tiles-content">
                                            <img *ngIf="event.amenityImage && !imageIsSvg(event.amenityImage)"
                                                 class="amenity-tiles-item-image" [src]="event.amenityImage">
                                            <div class="amenity-image-svg"
                                                 *ngIf="event.amenityImage && imageIsSvg(event.amenityImage)"
                                                 [ngStyle]="{'mask-image': 'url(' + event.amenityImage + ')',
                                                             '-webkit-mask-image': 'url(' + event.amenityImage + ')'}">
                                            </div>
                                            <div *ngIf="!event.amenityImage" class="amenity-tiles-item-image"></div>
                                        </div>
                                        <div class="amenity-tiles-item-name">{{event.amenityName}}</div>
                                    </div>
                                    <div class="event-info">
                                        <div class="m-b-xs">{{event.name}}</div>
                                        <div class="m-b-xs">
                                            <span class="m-r-sm">From: {{event.dateFrom | date:'dd.MM.yyyy hh:mm a'}}</span>
                                            To: {{event.dateTo | date:'dd.MM.yyyy hh:mm a'}}
                                        </div>
                                        <div class="m-b-xs">
                                            <span class="m-r-sm">Booked: {{event.bookings.length}}</span>
                                            <span *ngIf="event.maxNumberOfBookings">
                                                Max Number of Bookings: {{event.maxNumberOfBookings}}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div *ngIf="authService.userIsResident &&
                                        amenitiesService.amenitiesListForModal.length === 0 &&
                                        !amenitiesService.modalAmenitiesLoadingSpinnerShow">
                                <h3 style="text-align: center;">No amenities are available in your building.</h3>
                            </div>
                            <spinner [spinnerShow]="amenitiesService.modalAmenitiesLoadingSpinnerShow"></spinner>
                        </div>
                    </div>

                    <div class="tab-content" *ngIf="step == 'disclaimer'">
                        <div class="row text-center space-30 disclaimer-container">
                            <div class="row" *ngIf="disclaimerText">
                                <div class="col-md-12">
                                    <div class="acknowledgement-confirmation-textarea"
                                         [innerHTML]="disclaimerText | safeHtml"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-content" *ngIf="step == 'details'">
                        <!-- ___ Building ___ -->
                        <div [ngStyle]="{'display': authService.userIsResident? 'none':'block'}" class="row m-b-sm">
                            <div class="col-xs-4 col-md-4">
                                <label>Building</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                {{getBuildingNameById(data.buildingId)}}
                            </div>
                        </div>

                        <!-- ___ Booking Type ___ -->
                        <div class="row m-b-sm hidden" *ngIf="amenityType == 'hourly' || amenityType == 'range'">
                            <div class="col-xs-4 col-md-4">
                                <label>Type</label>
                            </div>
                            <div class="col-xs-8 col-md-8 text-capitalize">
                                {{bookingType}}
                            </div>
                        </div>

                        <!-- ___ Unit ___ -->
                        <div class="row m-b-sm"
                             [ngStyle]="{'display': authService.userIsResident || bookingType == 'event' ? 'none':'block'}">
                            <div class="col-xs-4 col-md-4">
                                <label style="margin-top: 4px;">Unit</label>
                            </div>

                            <div class="col-xs-8 col-md-8 fourteenPixelText">
                                <search-select [ngModel]="data.suiteId"
                                                name="suiteId"
                                                #suiteSelect
                                                (ngModelChange)="changeUnit($event)"
                                                [data]="suiteToSearchSelect(suites)"
                                                required>
                                </search-select>
                                <input *ngIf="suiteSelect.value == '0'" class="form-control"
                                                [(ngModel)]="data.suiteNumber"
                                                name="otherSuite"
                                                placeholder="Other Unit Number"
                                                maxlength="255">
                                <spinner [spinnerShow]="!suites.length && !isEditModeNoSpinner"></spinner>
                            </div>
                        </div>

                        <!-- ___ Resident ___ -->
                        <div class="row m-b-sm"
                             [ngStyle]="{'display': authService.userIsResident || bookingType == 'event' ? 'none':'block'}">
                            <div class="col-xs-4 col-md-4">
                                <label>Resident</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <select class="form-control"
                                        [(ngModel)]="data.residentId"
                                        name="residentId"
                                        #residentSelect
                                        (change)="changeResident($event.target.value)"
                                        [disabled]="!residents.length" required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let resident of residents" [value]="resident.id">{{resident.fullName}}</option>
                                </select>
                                <input *ngIf="suiteSelect.value == '0' || residentSelect.value == '0'"
                                        class="form-control"
                                        placeholder="Other Resident Name"
                                        [(ngModel)]="data.residentFullName"
                                        name="otherResident"
                                        maxlength="255">
                                <spinner [spinnerShow]="suiteSelect.value &&
                                                        suiteSelect.value != 'null' &&
                                                        !residents.length && !isEditModeNoSpinner"></spinner>
                            </div>
                        </div>

                        <!-- ___ Phone ___ -->
                        <div [ngStyle]="{'display': authService.userIsResident? 'none':'block'}" class="row m-b-sm">
                            <div class="col-xs-4 col-md-4"></div>
                            <div class="col-xs-8 col-md-8">
                                <i class="fa fa-phone" aria-hidden="true"></i>
                                {{residentPhone ? getFormattedPhone(residentPhone) : '-'}}
                            </div>
                        </div>

                        <!-- ___ Email ___ -->
                        <div [ngStyle]="{'display': authService.userIsResident? 'none':'block'}" class="row m-b-sm">
                            <div class="col-xs-4 col-md-4"></div>
                            <div class="col-xs-8 col-md-8">
                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                {{residentEmail ? residentEmail : '-'}}
                            </div>
                        </div>

                        <!-- ___ Occupancy ___ -->
                        <div class="row m-b-sm" [ngStyle]="{'display': authService.userIsResident || !residentOccupancy ? 'none':'block'}">
                            <div class="col-xs-4 col-md-4"></div>
                            <div class="col-xs-8 col-md-8">
                                <span class="label {{residentOccupancy}}-label">
                                    {{residentOccupancy ? residentOccupancyDisplayName : '-'}}
                                </span>
                            </div>
                        </div>

                        <!-- ___ Uses ___ -->
                        <div class="row m-b-sm" *ngIf="availableUses.length > 1 && bookingType != 'event' && !data.isEvent">
                            <div class="col-xs-4 col-md-4">
                                <label>Uses</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <select class="form-control" [(ngModel)]="data.uses" name="uses">
                                    <option *ngFor="let use of availableUses" [value]="use">{{use}}</option>
                                </select>
                            </div>
                        </div>

                        <!-- ___ Event Name ___ -->
                        <div class="row m-b-sm"
                             *ngIf="(amenityType == 'hourly' || amenityType == 'range') && bookingType == 'event'">
                            <div class="col-xs-4 col-md-4">
                                <label>Event Name</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <div class="input-group fourteenPixelText" style="width: 100%;">
                                    <input class="form-control"
                                           name="eventName"
                                           [(ngModel)]="eventName"
                                           required>
                                </div>
                            </div>
                        </div>

                        <!-- ___ Override ___ -->
                        <div class="row m-b-sm" *ngIf="overrideAvailable && !authService.userIsResident">
                            <div class="col-xs-4 col-md-4"></div>
                            <div class="col-xs-8 col-md-8">
                                <label class="img-checkbox">
                                    <input id="override"
                                           type="checkbox"
                                           name="override"
                                           (ngModelChange)="overrideSettingChanged($event)"
                                           [(ngModel)]="data.managementOverride">
                                    <label for="override">
                                        <svg-checked></svg-checked>
                                    </label>
                                    <span>Override</span>
                                </label>
                            </div>
                        </div>

                        <!-- ___ Day ___ -->
                        <div class="row m-b-sm" *ngIf="amenityType != 'hourly' && !data.isEvent">
                            <div class="col-xs-4 col-md-4">
                                <label>Day
                                    <span *ngIf="amenityType == 'daily'"> From</span>
                                </label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <div class="input-group fourteenPixelText" (click)="showCalendarDatepicker('day');">
                                    <input class="form-control"
                                            name="day" [(ngModel)]="data.day"
                                            [disabled]="gettingAmenityForEditing"
                                            required>
                                    <span class="input-group-addon">
                                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- ___ End Day ___ -->
                        <div class="row m-b-sm" *ngIf="amenityType == 'daily' && !data.isEvent">
                            <div class="col-xs-4 col-md-4">
                                <label>Day To</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <div class="input-group fourteenPixelText" (click)="showCalendarDatepicker('endDay');">
                                    <input class="form-control"
                                           name="endDay"
                                           [disabled]="!data.day"
                                           [(ngModel)]="data.endDay"
                                           required>
                                    <span class="input-group-addon">
                                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- ___ Hours ___ -->
                        <div *ngIf="amenityType == 'hourly' && !data.isEvent">
                            <div class="row m-b-sm">
                                <div class="col-xs-4 col-md-4">
                                    <label>Day From</label>
                                </div>
                                <div class="col-xs-8 col-md-8 day-and-hours-select-row">
                                    <div class="input-group fourteenPixelText" (click)="showCalendarDatepicker('day');">
                                        <input class="form-control" name="day"
                                               [(ngModel)]="data.day"
                                               [disabled]="gettingAmenityForEditing"
                                               required>
                                        <span class="input-group-addon">
                                            <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <div *ngIf="data.day && startTimeSelectValues.length > 0" class="time-select-wrapper">
                                        <mat-select class="form-control hours-select"
                                                    (selectionChange)="onStartHourChange($event)"
                                                    name="startHour"
                                                    (change)="endHour = ''"
                                                    [disabled]="showTimeSelectSpinner"
                                                    [(ngModel)]="startHour"
                                                    required>
                                            <mat-option value="" hidden></mat-option>
                                            <mat-option *ngFor="let hour of startTimeSelectValues"
                                                        [ngClass]="{'disabled' : isStartHourDisabled(hour)}"
                                                        [value]="hour"
                                                        [disabled]="isStartHourDisabled(hour)">
                                                {{hour.time}}
                                            </mat-option>
                                        </mat-select>
                                    </div>
                                    <div *ngIf="!data.day" class="dummy-select">
                                        <mat-select class="form-control hours-select" name="dummySelect1" disabled>
                                            <mat-option value="" hidden></mat-option>
                                        </mat-select>
                                    </div>
                                    <spinner [spinnerShow]="showTimeSelectSpinner" class="right-hourly-spinner"></spinner>
                                </div>
                            </div>
                            <div class="row m-b-sm">
                                <div class="col-xs-4 col-md-4">
                                    <label>Day To</label>
                                </div>
                                <div class="col-xs-8 col-md-8 day-and-hours-select-row">
                                    <div class="input-group fourteenPixelText"
                                        (click)="nextDayEndTimes.length ? showCalendarDatepicker('endDay') : true">
                                        <input  class="form-control"
                                                name="endDay"
                                                [(ngModel)]="data.endDay"
                                                [disabled]="!nextDayEndTimes.length || !data.day"
                                                required>
                                        <span class="input-group-addon">
                                            <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <div *ngIf="data.endDay && endTimeSelectValues.length > 0" class="time-select-wrapper">
                                        <mat-select class="form-control hours-select"
                                                    name="endHour"
                                                    [disabled]="showTimeSelectSpinner || !startHour"
                                                    [(ngModel)]="endHour"
                                                    required>
                                            <mat-option value="" hidden></mat-option>
                                            <mat-option *ngFor="let hour of endTimeSelectValues"
                                                        [ngClass]="{'disabled' : isEndHourDisabled(hour)}"
                                                        [value]="hour"
                                                        [disabled]="isEndHourDisabled(hour)">
                                                {{hour.time}}
                                            </mat-option>
                                        </mat-select>
                                        <spinner [spinnerShow]="showTimeSelectSpinner" class="right-hourly-spinner"></spinner>
                                    </div>
                                    <div *ngIf="!data.endDay || endTimeSelectValues.length < 1" class="dummy-select">
                                        <mat-select class="form-control hours-select" name="dummySelect1" disabled>
                                            <mat-option value="" hidden></mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ___ Time Range ___ -->
                        <div class="row m-b-sm" *ngIf="amenityType == 'range' && !data.isEvent">
                            <div class="col-xs-4 col-md-4">
                                <label>Time Range</label>
                            </div>
                            <div class="col-xs-8 col-md-8" *ngIf="!data.managementOverride">
                                <mat-select *ngIf="timeRangeSelectValues.length > 0"
                                            class="form-control"
                                            [panelClass]="'top-offset'"
                                            name="range"
                                            [(ngModel)]="timeSlot"
                                            [disabled]="showTimeSelectSpinner" required >
                                    <mat-option value="" hidden></mat-option>
                                    <mat-option *ngFor="let range of timeRangeSelectValues"
                                                [value]="range"
                                                [disabled]="!data.managementOverride && !range.available">
                                        {{range.time}}
                                    </mat-option>
                                </mat-select>
                                <div *ngIf="!data.day">Please select a day to see available ranges.</div>
                                <div *ngIf="data.day && timeRangeSelectValues.length < 1">
                                    There are no available ranges for day selected
                                </div>
                                <spinner [spinnerShow]="showTimeSelectSpinner"></spinner>
                            </div>
                            <div class="col-xs-8 col-md-8" *ngIf="data.managementOverride">
                                <div class="time-select-wrapper m-b-sm">
                                    <mat-select class="form-control hours-select"
                                                name="rangeOverrideStartHour"
                                                (change)="rangeOverrideStartHourChange()"
                                                [(ngModel)]="rangeOverrideStartHour"
                                                required>
                                        <mat-option value="" hidden></mat-option>
                                        <mat-option *ngFor="let hour of overrideTimeRangeSelectValues" [value]="hour">
                                            {{hour}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div class="time-select-wrapper">
                                    <mat-select class="form-control hours-select"
                                                name="rangeOverrideEndHour"
                                                (change)="rangeOverrideEndHourChange()"
                                                [disabled]="!rangeOverrideStartHour"
                                                [(ngModel)]="rangeOverrideEndHour"
                                                required>
                                        <mat-option value="" hidden></mat-option>
                                        <mat-option *ngFor="let hour of overrideTimeRangeSelectValues"
                                                    [ngClass]="{'disabled' : isOverrideEndHourDisabled(hour)}"
                                                    [value]="hour"
                                                    [disabled]="isOverrideEndHourDisabled(hour)">
                                            {{hour}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>

                        <!-- ___ Max # of Participants ___ -->
                        <div class="row m-b-sm"
                             *ngIf="(amenityType == 'hourly' || amenityType == 'range') && bookingType == 'event'">
                            <div class="col-xs-4 col-md-4">
                                <label>Max # of Participants</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <div class="input-group fourteenPixelText" style="width: 100%;">
                                    <input class="form-control"
                                           name="maxNumberOfParticipants"
                                           [(ngModel)]="maxNumberOfParticipants" required>
                                </div>
                            </div>
                        </div>

                        <!--&lt;!&ndash; ___ Repeat Until ___ &ndash;&gt;-->
                        <!--<div class="row m-b-sm"-->
                             <!--*ngIf="(amenityType == 'hourly' || amenityType == 'range') && bookingType == 'event'">-->
                            <!--<div class="col-xs-4 col-md-4">-->
                                <!--<label>Repeat Until</label>-->
                            <!--</div>-->
                            <!--<div class="col-xs-8 col-md-8">-->
                                <!--<mat-form-field class="bookings-repeat-select">-->
                                    <!--<mat-select>-->
                                        <!--<mat-option value="daily">Daily</mat-option>-->
                                        <!--<mat-option value="weekly">Weekly</mat-option>-->
                                        <!--<mat-option value="monthly">Monthly</mat-option>-->
                                        <!--<mat-option value="yearly">Yearly</mat-option>-->
                                        <!--<mat-option (click)="showCustomRepeat()" value="custom">Custom...</mat-option>-->
                                    <!--</mat-select>-->
                                <!--</mat-form-field>-->
                            <!--</div>-->
                        <!--</div>-->

                        <!--<div class="row m-b-sm"-->
                             <!--*ngIf="(amenityType == 'hourly' || amenityType == 'range') && bookingType == 'event'">-->
                            <!--<div class="col-xs-4 col-md-4">-->
                                <!--<label>Can Be Booked By</label>-->
                            <!--</div>-->
                            <!--<div class="col-xs-8 col-md-8 can-be-booked-by-multiselect">-->
                                <!--<multiselect-field-->
                                    <!--name="canBeBookedBy"-->
                                    <!--[editOnly]="true"-->
                                    <!--[data]="testValues"-->
                                    <!--[(ngModel)]="testValue">-->
                                <!--</multiselect-field>-->
                            <!--</div>-->
                        <!--</div>-->

                        <!-- ___ Notes  ___ -->
                        <div *ngIf="!authService.userIsResident && bookingType != 'event'" class="row m-b-sm">
                            <div class="col-xs-4 col-md-4">
                                <label>Notes</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <textarea class="form-control" name="notes" [(ngModel)]="note" maxlength="255"></textarea>
                            </div>
                        </div>

                        <!--<div *ngIf="showQuoteCheckbox()"-->
                             <!--class="row">-->
                             <!--<div class="img-checkbox col-sm-12">-->
                                <!--<input type="checkbox"-->
                                       <!--id="viewPricingCheckbox"-->
                                       <!--name="viewPricingCheckbox"-->
                                       <!--[(ngModel)]="viewPricingCheckbox"-->
                                       <!--required>-->
                                <!--<label for="viewPricingCheckbox">-->
                                    <!--<svg-checked></svg-checked>-->
                                    <!--<span class="clickable">-->
                                        <!--I would like to view pricing for local verified moving companies in my area.-->
                                    <!--</span>-->
                                <!--</label>-->
                            <!--</div>-->
                        <!--</div>-->

                        <div *ngIf="showCalendarDatePicker" class="calendar-datepicker">
                            <div class="status-legend-wrapper">
                                <div class="m-b-xs status-legend">
                                    <div class="col-sm-4">
                                        <div class="amenity-color available"></div>
                                        <label>
                                            <span>Available</span>
                                        </label>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="amenity-color booked"></div>
                                        <label>
                                            <span>Booked</span>
                                        </label>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="amenity-color closed"></div>
                                        <label>
                                            <span>Closed</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div id="modalCalendar"></div>
                            <spinner [spinnerShow]="showCalendarSpinner"></spinner>
                        </div>
                        <div *ngIf="showCustomRepeatWindow" class="custom-repeat-window">
                            <!-- ___ Repeat Every  ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-4">
                                    <label>Repeat Every</label>
                                </div>
                                <div class="col-md-8 inline-input-select">
                                    <input type="text" class="form-control"
                                           name="repeatEvery" [ngModel]="repeatEvery" maxlength="255">
                                    <select class="form-control" name="repeatUntil">
                                        <option value="day">Day</option>
                                        <option value="week">Week</option>
                                        <option value="month">Month</option>
                                        <option value="year">Yeary</option>
                                    </select>
                                </div>
                            </div>
                            <!-- ___ Repeat On  ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-4">
                                    <label>Repeat On</label>
                                </div>
                            </div>
                            <div class="row m-b-sm">
                                <div class="col-md-12">
                                    <button type="button" [ngClass]="{'active' : repeatOn.indexOf('Monday') != -1}"
                                            (click)="addDayToRepeatArray('Monday')" class="day-button"
                                            mat-mini-fab>M</button>
                                    <button type="button" [ngClass]="{'active' : repeatOn.indexOf('Tuesday') != -1}"
                                            (click)="addDayToRepeatArray('Tuesday')"
                                            class="day-button" mat-mini-fab>T</button>
                                    <button type="button" [ngClass]="{'active' : repeatOn.indexOf('Wednesday') != -1}"
                                            (click)="addDayToRepeatArray('Wednesday')"
                                            class="day-button" mat-mini-fab>W</button>
                                    <button type="button" [ngClass]="{'active' : repeatOn.indexOf('Thursday') != -1}"
                                            (click)="addDayToRepeatArray('Thursday')"
                                            class="day-button" mat-mini-fab>T</button>
                                    <button type="button" [ngClass]="{'active' : repeatOn.indexOf('Friday') != -1}"
                                            (click)="addDayToRepeatArray('Friday')" class="day-button"
                                            mat-mini-fab>F</button>
                                    <button type="button" [ngClass]="{'active' : repeatOn.indexOf('Saturday') != -1}"
                                            (click)="addDayToRepeatArray('Saturday')"
                                            class="day-button" mat-mini-fab>S</button>
                                    <button type="button" [ngClass]="{'active' : repeatOn.indexOf('Sunday') != -1}"
                                            (click)="addDayToRepeatArray('Sunday')"
                                            class="day-button" mat-mini-fab>S</button>
                                </div>
                            </div>
                            <!-- ___ Ends  ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-4">
                                    <label>Ends</label>
                                </div>
                            </div>
                            <mat-radio-group class="example-radio-group" name="ends" [(ngModel)]="ends">
                                <!-- ___ Never  ___ -->
                                <div class="row m-b-sm">
                                    <div class="col-md-4">
                                        <mat-radio-button class="example-radio-button" value="never">
                                            Never
                                        </mat-radio-button>
                                    </div>
                                </div>
                                <!-- ___ On  ___ -->
                                <div class="row m-b-sm">
                                    <div class="col-md-4">
                                        <mat-radio-button class="example-radio-button" value="on">
                                            On
                                        </mat-radio-button>
                                    </div>
                                    <div class="col-md-8 directory-add-modal-date-field">
                                        <mat-form-field>
                                            <input matInput
                                                    [(ngModel)]="endOn"
                                                    name="endOn"
                                                    [disabled]="ends != 'on'"
                                                    (focus)="picker.open()"
                                                    (click)="picker.open()"
                                                    [matDatepicker]="picker"
                                                    placeholder="Choose a date">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <!-- ___ Repeat Every  ___ -->
                                <div class="row m-b-sm">
                                    <div class="col-md-4">
                                        <mat-radio-button class="example-radio-button" value="after">
                                            After
                                        </mat-radio-button>
                                    </div>
                                    <div class="col-md-8 inline-input-div">
                                        <input type="text" class="form-control"
                                                [disabled]="ends != 'after'"
                                                name="endAfter"
                                                [ngModel]="endAfter"
                                                maxlength="255">
                                        <div>Occurrence</div>
                                    </div>
                                </div>
                            </mat-radio-group>
                            <div class="row m-b-sm">
                                <div class="col-md-6 custom-repeat-window-buttons">
                                    <label (click)="showCustomRepeatWindow = false;">CANCEL</label>
                                    <label (click)="showCustomRepeatWindow = false;" class="mtv-primary-color">DONE</label>
                                </div>
                            </div>
                        </div>
                        <spinner [spinnerShow]="gettingAmenityForEditing"></spinner>
                    </div>
                    <div class="tab-content" *ngIf="step == 'terms'">
                        <!-- ___ Notes  ___ -->
                        <div class="row" *ngIf="termsAndConditions">
                            <div class="col-md-12">
                                <div class="acknowledgement-confirmation-textarea"
                                     [innerHTML]="termsAndConditions | safeHtml"></div>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="amenityConfirmationMessage">
                            <div class="img-checkbox col-sm-12">
                                <input type="checkbox" id="acknowledgementCheckbox"
                                        name="acknowledgement"
                                        [(ngModel)]="data.acknowledgement"
                                        required>
                                <label for="acknowledgementCheckbox">
                                    <svg-checked></svg-checked>
                                    <span class="clickable">{{amenityConfirmationMessage}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="tab-content" *ngIf="step == 'payment'">
                        <div class="row m-b-sm fees-container"
                             [ngStyle]="{'display': fee.active ? '' : 'none'}"
                             *ngFor="let fee of amenityFees; let index = index">
                            <div class="img-checkbox">
                                <span class="col-xs-6 col-sm-6">
                                    <input type="checkbox"
                                           id="feeRequired{{index}}"
                                           name="feeRequired{{index}}"
                                           [hidden]="fee.waived"
                                           [disabled]="ifRequired(fee) || fee.waived"
                                           [(ngModel)]="fee.include"
                                           (ngModelChange)="removePaidStatus($event, fee)">
                                    <label class="with-checkbox clickable" for="feeRequired{{index}}">
                                        <svg-checked [hidden]="fee.waived"></svg-checked>
                                        {{fee.name}}{{fee.refundable ? ' (Refundable)': ''}}
                                    </label>
                                </span>
                                <span class="col-xs-3 col-sm-3 clickable" *ngIf="!authService.userIsResident">
                                    <span *ngIf="!fee.waived">
                                        <input type="checkbox" id="feePaid{{index}}"
                                                [disabled]="!fee.include || data.paymentMethod == 'credit_card' || data.id || authService.userIsResident"
                                                name="feePaid{{index}}"
                                                [(ngModel)]="fee.status">
                                        <label class="with-checkbox clickable" for="feePaid{{index}}" style="margin-right: 5px;" >
                                            <svg-checked></svg-checked>
                                            Paid
                                        </label>
                                    </span>
                                    <span *ngIf="fee.waived">Waived</span>
                                </span>
                                <span class="col-xs-3 col-sm-3" *ngIf="authService.userIsResident">Not Paid</span>
                                <span class="col-xs-3 col-sm-3">
                                    {{'$' + fee.amount}}
                                    <span *ngIf="fee.availableWaive && !fee.waived && !authService.userIsResident"
                                          class="pull-right text-red clickable"
                                          (click)="fee.waived = true;">
                                        Waive
                                    </span>
                                    <span *ngIf="fee.availableWaive && fee.waived && !authService.userIsResident"
                                          class="pull-right text-red clickable"
                                          (click)="fee.waived = false;">
                                        Do
                                    </span>
                                </span>
                            </div>
                        </div>

                        <hr>

                        <div class="row m-b-sm align-col-xs-4-right"
                             *ngFor="let paidFee of amenityFees"
                             [ngStyle]="{'display': paidFee.active && !paidFee.waived ? '' : 'none'}">
                            <div *ngIf="paidFee.include">
                                <div class="col-xs-8 col-md-9">
                                    <label class="text-capitalize">{{paidFee.name}}</label>
                                </div>
                                <div class="col-xs-4 col-md-3 fourteenPixelText">
                                    <span *ngIf="paidFee.pmtAtTime && getStartEndDayDifference() > 1">
                                        {{getStartEndDayDifference() + ' x '}}
                                    </span>
                                    <span *ngIf="paidFee.pmtHourly && getStartEndHourDifference() > 1">
                                        {{getStartEndHourDifference() + ' x '}}
                                    </span>
                                    <span>{{'$' + paidFee.amount}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="row m-b-sm sixteen-pixel-bold align-col-xs-4-right" *ngIf="getTotalRefundableValue() != '0.00'">
                            <div class="col-xs-8 col-md-9">
                                <label>Total Refundable</label>
                            </div>
                            <div class="col-xs-4 col-md-3 mtv-primary-color">
                                {{'$' + getTotalRefundableValue()}}
                            </div>
                        </div>

                        <div class="row m-b-sm sixteen-pixel-bold align-col-xs-4-right"
                             *ngIf="getReservationProcessingFeeValue() != '0.00' && data.paymentMethod == 'credit_card'">
                            <div class="col-xs-8 col-md-9">
                                <label>Reservation Processing Fee</label>
                            </div>
                            <div class="col-xs-4 col-md-3 mtv-primary-color">
                                {{'$' + getReservationProcessingFeeValue()}}
                            </div>
                        </div>

                        <div class="row m-b-sm sixteen-pixel-bold align-col-xs-4-right">
                            <div class="col-xs-8 col-md-9">
                                <label>Total Payment Due</label>
                            </div>
                            <div class="col-xs-4 col-md-3 mtv-primary-color">
                                {{'$' + getTotalCharged()}}
                            </div>
                        </div>

                        <hr *ngIf="includedFieldsExist()">

                        <!-- ___ Payment Method ___ -->
                        <div class="row m-b-sm" *ngIf="includedFieldsExist()">
                            <div class="col-xs-5 col-md-5">
                                <label>Payment Method</label>
                            </div>
                            <div class="col-xs-7 col-md-7">
                                <select class="form-control" name="paymentMethod" [disabled]="paymentMethodSelectDisabled"
                                        (ngModelChange)="changePaymentType($event)" [(ngModel)]="data.paymentMethod">
                                    <option *ngFor="let method of availablePaymentMethods"
                                            [value]="method.value">{{method.displayName}}</option>
                                </select>
                            </div>
                        </div>
                        <div *ngIf="data.paymentMethod == 'credit_card' && includedFieldsExist()">
                            <!-- ___ Stripe Card Info ___ -->
                            <div class="row m-b-sm" *ngIf="!data.isPayByLink">
                                <div class="col-xs-5 col-md-5">
                                    <label>Card Info</label>
                                </div>
                                <div class="col-xs-7 col-md-7 no-stripe-submit-button">
                                    <stripe-payment (setter)="setCard($event)" (onSuccess)="onStripeSuccess(form)">
                                    </stripe-payment>
                                </div>
                            </div>

                            <!-- ___ isPayByLink checkbox ___ -->
                            <div class="row m-b-sm" *ngIf="!authService.userIsResident && residentEmail">
                                <div class="col-xs-5 col-md-5"></div>
                                <div class="col-xs-7 col-md-7 no-stripe-submit-button">
                                    <label class="img-checkbox">
                                        <input type="checkbox"
                                               id="isPayByLink"
                                               name="isPayByLink"
                                               [(ngModel)]="data.isPayByLink"
                                               (change)="onPayByLinkCheckboxChange($event)">
                                        <label for="isPayByLink"><svg-checked></svg-checked></label>
                                        <span class="fourteenPixelText">Send payment link to the resident</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-content" *ngIf="step == 'summary'">
                        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
                            <div class="col-xs-6 col-md-6">
                                <label>Building</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                {{getBuildingNameById(data.buildingId)}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="!authService.userIsResident && bookingType != 'event'">
                            <div class="col-xs-6 col-md-6">
                                <label>Unit</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                {{data.suiteNumber}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="!authService.userIsResident && bookingType != 'event'">
                            <div class="col-xs-6 col-md-6">
                                <label>Resident</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                <div *ngIf="residentOccupancy" class="label {{residentOccupancy}}-label m-r-xs">
                                    {{residentOccupancy ? residentOccupancyDisplayName : '-'}}
                                </div>
                                <div>{{data.residentFullName}}</div>
                            </div>
                        </div>

                        <div class="row m-b-sm"  *ngIf="amenityType != 'eventBooking'">
                            <div class="col-xs-6 col-md-6">
                                <label>Day From</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                {{data.day}}
                            </div>
                        </div>
                        <div class="row m-b-sm" *ngIf="amenityType == 'daily' ||
                                                (amenityType == 'hourly' && data.endDay && data.endDay != data.day)">
                            <div class="col-xs-6 col-md-6">
                                <label>Day To</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                {{data.endDay}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="amenityType == 'eventBooking'">
                            <div class="col-xs-6 col-md-6">
                                <label>Day From</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                {{data.day | date:'dd.MM.yyyy hh:mm a'}}
                            </div>
                        </div>
                        <div class="row m-b-sm" *ngIf="amenityType == 'eventBooking'">
                            <div class="col-xs-6 col-md-6">
                                <label>Day To</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                {{data.endDay | date:'dd.MM.yyyy hh:mm a'}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="amenityType == 'hourly' || amenityType == 'range'">
                            <div class="col-xs-6 col-md-6">
                                <label>Hours</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText" *ngIf="amenityType == 'hourly'">
                                {{startHour.time}} - {{endHour.time}}
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText" *ngIf="amenityType == 'range'">
                                {{timeSlot.time}}
                            </div>
                        </div>

                        <br *ngIf="availablePaymentMethods.length">

                        <div class="row m-b-sm" *ngIf="availablePaymentMethods.length">
                            <div class="col-xs-6 col-md-6">
                                <label>Method of Payment</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText text-capitalize">
                                <span *ngIf="data.paymentMethod == 'cash'">Cash</span>
                                <span *ngIf="data.paymentMethod == 'cheque'">Cheque</span>
                                <span *ngIf="data.paymentMethod == 'credit_card'">Credit Card</span>
                                <span *ngIf="data.paymentMethod == 'certified_cheque'">Certified Cheque</span>
                                <span *ngIf="data.paymentMethod == 'money_order'">Money Order</span>
                                <span *ngIf="data.paymentMethod == 'bank_draft'">Bank Draft</span>
                                <span *ngIf="data.paymentMethod == 'custom_type'">
                                    {{availablePaymentMethods[availablePaymentMethods.length - 1].displayName}}
                                </span>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="availablePaymentMethods.length">
                            <div class="col-xs-6 col-md-6">
                                <label>Total Charges</label>
                            </div>
                            <div class="col-xs-6 col-md-6 fourteenPixelText">
                                {{'$' + getTotalCharged()}}
                            </div>
                        </div>

                        <spinner [spinnerShow]="confirmationSpinner"></spinner>
                    </div>
                    <div class="tab-content" *ngIf="step == 'quotes'">
                        <div *ngIf="quoteStep == 'price-list'">
                            <div class="col-sm-12 m-b-md bold fourteenPixelText">
                                We can help you book experienced movers without a large minimum! <br>
                                Rate includes 2 movers and a truck.
                            </div>

                            <div class="col-sm-12 m-b-xs fourteenPixelText">
                                For the first 1.5 hours <span class="pull-right">$150</span>
                            </div>

                            <div class="col-sm-12 m-b-md fourteenPixelText">
                                For each additional hour <span class="pull-right">$99</span>
                            </div>

                            <div class="col-sm-12 m-b-md" style="color: #afb1b2;">
                                Appliances, fitness equipment, disposal, storage, stairs and out-of-town moves are extra and will be quoted by your Pro.
                            </div>

                            <mat-radio-group class="example-radio-group" name="acceptOffer" [(ngModel)]="acceptOffer">
                                <!-- ___ Never  ___ -->
                                <div class="row m-b-sm">
                                    <div class="col-md-4">
                                        <mat-radio-button class="example-radio-button" [value]="1">
                                            Call me and we'll chat over the phone
                                        </mat-radio-button>
                                    </div>
                                </div>
                                <!-- ___ On  ___ -->
                                <div class="row m-b-sm">
                                    <div class="col-md-4">
                                        <mat-radio-button class="example-radio-button" [value]="0">
                                            Leave me alone, I am not interested.
                                        </mat-radio-button>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>

                        <div *ngIf="quoteStep == 'cancelled'">
                            <h4>OK, no problem. We understand you are not interested.<br> Can you tell us why?</h4>
                            <div *ngFor="let answer of answers">
                                <label class="img-checkbox">
                                    <input type="checkbox" id="{{answer.id}}" name="answer{{answer.id}}" [(ngModel)]="answer.checked">
                                    <label for="{{answer.id}}"><svg-checked></svg-checked></label>
                                    <span class="fourteenPixelText">{{answer.answer}}</span>
                                </label>
                                <br *ngIf="answer.id == '5' && answer.checked">
                                <textarea *ngIf="answer.id == '5' && answer.checked"
                                          class="other-reject-reason-textarea"
                                          [(ngModel)]="otherReason"
                                          name="otherReason">
                                </textarea>
                            </div>
                        </div>

                        <div *ngIf="quoteStep == 'confirm-phone'">
                            <div class="image-wrapper">
                                <img src="/assets/img/quote-phone-img.png">
                            </div>
                            <div class="bold text-center">
                                The phone # we have for you is {{getFormattedPhone(residentPhone)}}<br>
                                is the best number to reach you at?
                            </div>
                        </div>

                        <div *ngIf="quoteStep == 'enter-phone'">
                            <div class="image-wrapper">
                                <img src="/assets/img/quote-phone-img.png">
                            </div>
                            <div class="bold text-center">
                                What is the best best number to get in touch with you?
                            </div>
                            <input class="form-control phone-input" name="residentPhone" [(ngModel)]="residentPhone" required>
                        </div>
                    </div>

                    <div class="button-row row text-center space-30">
                        <button *ngIf="step == 'amenity'"
                                class="btn btn-primary submit-btn"
                                type="submit" [disabled]="isContinueButtonDisabled('amenity')"
                                (click)="moveToTheNextStep(termsAndConditions || amenityConfirmationMessage ? 'terms' : 'details')">
                            Continue
                        </button>

                        <button *ngIf="step == 'disclaimer'"
                                class="btn btn-primary submit-btn"
                                type="submit"
                                [disabled]="isContinueButtonDisabled('amenity')"
                                (click)="moveToTheNextStep((availablePaymentMethods.length && amenityFees.length) ? 'payment' : (showQuoteCheckbox() ? 'quotes' : 'summary'))">
                            I agree
                        </button>

                        <button *ngIf="step == 'details'"
                                class="btn btn-primary submit-btn"
                                type="submit"
                                (click)="moveToTheNextStep(disclaimerText ? 'disclaimer' : ((availablePaymentMethods.length && amenityFees.length) ? 'payment' : (showQuoteCheckbox() ? 'quotes' : 'summary')))">
                            Continue
                        </button>

                        <button *ngIf="step == 'terms'"
                                class="btn btn-primary submit-btn"
                                type="submit"
                                [disabled]="isContinueButtonDisabled('terms')"
                                (click)="moveToTheNextStep('details')">
                            Continue
                        </button>

                        <button  *ngIf="step == 'payment'"
                                 class="btn btn-primary submit-btn"
                                 type="submit"
                                 [disabled]="isContinueButtonDisabled('payment')"
                                 (click)="data.paymentMethod == 'credit_card' && !data.isPayByLink && includedFieldsExist() ? clickStripeHiddenButton() : (showQuoteCheckbox() ? showQuote() : moveToTheNextStep('summary'))">
                            Continue
                        </button>

                        <button *ngIf="step == 'quotes' && quoteStep == 'price-list'"
                                class="btn btn-primary submit-btn"
                                (click)="acceptOffer ? (quoteStep = (residentPhone ? 'confirm-phone' : 'enter-phone')) : quoteStep = 'cancelled'">
                            Next
                        </button>

                        <div *ngIf="step == 'quotes' && quoteStep == 'cancelled'" class="text-center">
                            <button class="btn mtv-primary-color mtv-primary-border" (click)="quoteStep = 'price-list'">
                                Back
                            </button>

                            <button class="btn btn-primary submit-btn" (click)="getNewQuote(false)">
                                Continue
                            </button>
                        </div>

                        <div *ngIf="step == 'quotes' && quoteStep == 'confirm-phone'" class="text-center">
                            <button class="btn mtv-primary-color mtv-primary-border" (click)="quoteStep = 'enter-phone'">
                                No
                            </button>

                            <button class="btn btn-primary submit-btn" (click)="getNewQuote(true)">
                                Yes
                            </button>
                        </div>

                        <button *ngIf="step == 'quotes' && quoteStep == 'enter-phone'"
                                class="btn btn-primary submit-btn"
                                [disabled]="!residentPhone"
                                (click)="getNewQuote(true)">
                            Continue
                        </button>

                        <button *ngIf="step == 'summary'"
                                class="btn btn-primary submit-btn"
                                [disabled]="disabledSubmit"
                                (click)="confirmBooking()">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-modal/amenities-modal.component.html